// src/components/Hero.js
import React from 'react';
import './Hero.css'; // Optional for custom styles

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Hi, I'm [Kailerk Treetipsounthorn]</h1>
        <p>A [Your Profession]</p>
        <button className="cta">Explore My Work</button>
      </div>
    </section>
  );
}

export default Hero;
